import React from 'react'

interface GalleryScaffoldProps {
  isLoading: boolean
  empty: boolean
  emptyMessage?: string
  children: React.ReactNode
}

const GalleryScaffold: React.FC<GalleryScaffoldProps> = ({
  isLoading,
  empty,
  emptyMessage = 'No items available.',
  children,
}) => {
  return (
    <div className="d-flex flex-column h-100" style={{ minHeight: 0 }}>
      {isLoading ? (
        <div className="d-flex justify-content-center align-items-center flex-grow-1">
          <div className="spinner-border" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      ) : empty ? (
        <div className="d-flex justify-content-center align-items-center flex-grow-1">
          <p className="text-muted m-0">{emptyMessage}</p>
        </div>
      ) : (
        <div className="flex-grow-1 overflow-auto p-3">{children}</div>
      )}
    </div>
  )
}

export default GalleryScaffold
